import {createTheme} from '@mui/material/styles';

export const theme = createTheme({
  primary: '#616B88',
  secondary: '#616B88',
  palette: {
    primary: {
      main: '#616B88',
    },
    secondary: {
      main: '#616B88',
    },
  },
  components: {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          paddingLeft: 24,
          paddingRight: 24,
          paddingBottom: 24,
          '& button': {
            minWidth: 80,
            height: 35,
          },
        },
      },
    },
  },
});
